// Material UI
import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

const Success = () => {
    return(
        <Container>
            <Box 
                m="auto"
                sx={{ 
                    marginTop: '100px',
                    width: '800px',
                }}
            >    
                <Typography variant="h4">
                    Thank you!
                </Typography>
                <br />
                <Typography 
                    variant="body1"
                    sx={{
                        marginLeft: '40px', 
                        marginRight: '40px'
                    }}
                >
                    We have received your donation. Thank you very much for your support!
                    Please reach out to us at <a href="mailto:hello@super-agent.com">hello@super-agent.com</a> at any time if you have any suggestions or comments. 
                </Typography>
            </Box>
        </Container>
    )
}

export default Success;
